import React, { Suspense } from 'react';
import { importRemote } from 'module-federation-import-remote';
import { ErrorBoundary, PageLoading } from '@dtna/dvs-core-dcp-ui-libraries';
import { getMfeUrl } from '@dtna/dvs-core-dcp-client-utils/lib/utils/mfe';

import { store, context } from 'store';
import { mfeLazyLoadErrorHandler } from 'utils/mfe';

const XOTAIndex = React.lazy(() => importRemote<any>({
  url: getMfeUrl('XOTA_INDEX'),
  scope: 'XOTAIndex',
  module: 'App',
  bustRemoteEntryCache: false,
}).catch(mfeLazyLoadErrorHandler));

interface XOTAIndexWrapperProps {
  navbarLoaded?: boolean;
}

export default function XOTAIndexWrapper({
  navbarLoaded,
}: XOTAIndexWrapperProps) {
  return (
    <Suspense fallback={<PageLoading navbarLoaded={navbarLoaded} />}>
      <ErrorBoundary>
        <XOTAIndex store={store} context={context} />
      </ErrorBoundary>
    </Suspense>
  );
}
